let BuildNumber=function(){return 'Sprint 16 Nov 2022';};export default BuildNumber;



// WEBPACK FOOTER //
// ./client/app/common/services/buildNumber.service.js